// extracted by mini-css-extract-plugin
export default {"img":"Img_img__Nvmbj"};